// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchresult_searchresult__lAM2A{
    box-shadow:-2px -3px 6px #FFFFFF, 0px 3px 6px #00000026;
    border-radius: 20px;
    padding: 20px 0 20px 0px;
}

.searchresult_searchresult__lAM2A>div{
box-sizing: border-box;
overflow-y: scroll;
height: 812px;
scrollbar-width: thin;
scrollbar-color:#6b71c9;
width: -moz-available;
}
.searchresult_searchresult__lAM2A::-webkit-scrollbar{
    
width: 4px;
    
}


  .searchresult_searchresult__lAM2A::-webkit-scrollbar-thumb {
    background: #707070; 
    border-radius: 10px;
    
  }
  .searchresult_searchresult__lAM2A::-webkit-scrollbar-thumb:hover {
    background: #6b71c9; 
  }
  .searchresult_loadingspinner__h28-a{
    position: absolute;
    top: 25%;
    left: 50%;
  }
  .searchresult_noofsearchresuts__2c199{
    display: flex;
    margin:0;
    align-items: center;
    margin-left: 20px;
  }
  .searchresult_noofsearchresuts__2c199>p{
  margin: 2px 0 0 0;
  font-size: 22px;
  color: #373334;
  }
  .searchresult_noofsearchresuts__2c199>a{
    margin-right: 13px;
  }`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/searchresult.module.css"],"names":[],"mappings":"AAAA;IACI,uDAAuD;IACvD,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;AACA,sBAAsB;AACtB,kBAAkB;AAClB,aAAa;AACb,qBAAqB;AACrB,uBAAuB;AACvB,qBAAqB;AACrB;AACA;;AAEA,UAAU;;AAEV;;;EAGE;IACE,mBAAmB;IACnB,mBAAmB;;EAErB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;EACX;EACA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,iBAAiB;EACnB;EACA;EACA,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd;EACA;IACE,kBAAkB;EACpB","sourcesContent":[".searchresult{\r\n    box-shadow:-2px -3px 6px #FFFFFF, 0px 3px 6px #00000026;\r\n    border-radius: 20px;\r\n    padding: 20px 0 20px 0px;\r\n}\r\n\r\n.searchresult>div{\r\nbox-sizing: border-box;\r\noverflow-y: scroll;\r\nheight: 812px;\r\nscrollbar-width: thin;\r\nscrollbar-color:#6b71c9;\r\nwidth: -moz-available;\r\n}\r\n.searchresult::-webkit-scrollbar{\r\n    \r\nwidth: 4px;\r\n    \r\n}\r\n\r\n\r\n  .searchresult::-webkit-scrollbar-thumb {\r\n    background: #707070; \r\n    border-radius: 10px;\r\n    \r\n  }\r\n  .searchresult::-webkit-scrollbar-thumb:hover {\r\n    background: #6b71c9; \r\n  }\r\n  .loadingspinner{\r\n    position: absolute;\r\n    top: 25%;\r\n    left: 50%;\r\n  }\r\n  .noofsearchresuts{\r\n    display: flex;\r\n    margin:0;\r\n    align-items: center;\r\n    margin-left: 20px;\r\n  }\r\n  .noofsearchresuts>p{\r\n  margin: 2px 0 0 0;\r\n  font-size: 22px;\r\n  color: #373334;\r\n  }\r\n  .noofsearchresuts>a{\r\n    margin-right: 13px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchresult": `searchresult_searchresult__lAM2A`,
	"loadingspinner": `searchresult_loadingspinner__h28-a`,
	"noofsearchresuts": `searchresult_noofsearchresuts__2c199`
};
export default ___CSS_LOADER_EXPORT___;
